import { defineStore } from "pinia";
import { Method } from "~/enums";
import { useLocalStorage, useSessionStorage } from "@vueuse/core";
import moment from "moment";

import {
	ContractInfo,
	EquipComponent,
	EquipInstallInfo,
	EventInfo,
  EquipInfo,
	FaultTrendInfo,
	ManagerInfo,
	MonitoringByAllInfo,
	MonitoringBySourceInfo,
	OwnerInfo,
	ProdInfoStatus,
	ProdTrend,
	ProdTrendsInfo,
	MobileReportInfo,
} from "~/models/dto-types";
import { useUserStore } from "./userStore";
import { useEtcStore } from "./etcStore";
import Swal from "sweetalert2";

interface ConvertSiteForm {
	cid: string;
	siteName: string;
	ownerSeq: number;
	rtuId: string;
	latitude: number;
	longitude: number;
	siteAddr: string;
	dongCode: string;
	equipList: EquipInfo[];
}

export const useEquipStore = defineStore("equipStore", {
	state: () => ({
		engSourceName: [
			{
				name: "pv",
				key: "10",
			},
			{
				name: "solarheat",
				key: "20",
			},
			{
				name: "geo",
				key: "30",
			},
			{
				name: "wf",
				key: "40",
			},
			{
				name: "wf",
				key: "50",
			},
			{
				name: "fuelcell",
				key: "60",
			},
			{
				name: "ess",
				key: "70",
			},
		],
		equipCid: useSessionStorage("equipCid", "" as string),
		plainEquipList: useLocalStorage("plainEquipList", [] as EquipInfo[]),
		equipInfo: useLocalStorage("equipInfo", []),
		equipDetailInfoList: useSessionStorage("equipDetailInfoList", [] as EquipInfo[]),
		selectEquipMeasure: useSessionStorage("selectEquipMeasure", {}),
		selectEquipInstall: useSessionStorage("selectEquipInstall", {} as EquipInstallInfo),
		selectEquipInfo: useSessionStorage("selectEquipInfo", {} as EquipInfo),
		selectEquipSpec: useSessionStorage("selectEquipSpec", {} as EquipComponent),
		selectEquipRtu: useSessionStorage("selectEquipRtu", {}),
		selectEquipMonitoringSource: useSessionStorage("selectEquipMonitoringSource", {} as MonitoringBySourceInfo),
		mapEquipInfoList: [],
		convertSiteList: useSessionStorage("convertSiteList", [] as ConvertSiteForm[]),
		selectSiteInfo: useSessionStorage("selectSiteInfo", {} as ConvertSiteForm),
	}),
	getters: {
		getEquipCid(state) {
			return state.selectEquipInfo.cid;
		},
	},
	// hydrate(state, initialState) {
	// 	state.equipInfo = useLocalStorage("equipInfo", initialState.equipInfo);
	// 	state.equipCid = useLocalStorage("equipCid", initialState.equipCid);
	// 	state.plainEquipList = useLocalStorage("plainEquipList", initialState.plainEquipList);
	// 	state.equipInfo = useLocalStorage("equipInfo", initialState.equipInfo);
	// 	state.equipDetailInfoList = useLocalStorage("equipDetailInfoList", initialState.equipDetailInfoList);
	// 	state.selectEquipMeasure = useLocalStorage("selectEquipMeasure", initialState.selectEquipMeasure);
	// 	state.selectEquipInstall = useLocalStorage("selectEquipInstall", initialState.selectEquipInstall);
	// 	state.selectEquipInfo = useLocalStorage("selectEquipInfo", initialState.selectEquipInfo);
	// 	state.selectEquipSpec = useLocalStorage("selectEquipSpec", initialState.selectEquipSpec);
	// 	state.selectEquipRtu = useLocalStorage("selectEquipRtu", initialState.selectEquipRtu);
	// 	state.selectEquipMonitoringSource = useLocalStorage("selectEquipMonitoringSource", initialState.selectEquipMonitoringSource);
	// 	state.mapEquipInfoList = useLocalStorage("mapEquipInfoList", initialState.mapEquipInfoList);
	// 	state.convertSiteList = useLocalStorage("convertSiteList", initialState.convertSiteList);
	// 	state.selectSiteInfo = useLocalStorage("selectSiteInfo", initialState.selectSiteInfo);
	// },
	actions: {
    async initEquipList(engSource: string | undefined = undefined, cityCode: string | undefined = undefined, sigunguCode: string | undefined = undefined, dongCode: string | undefined = undefined) {
      if(engSource === null) engSource = undefined;
      if(cityCode === null) cityCode = undefined;
      if(sigunguCode === null) sigunguCode = undefined;
      if(dongCode === null) dongCode = undefined;

      const res = await useCustomFetch<EquipInfo[]>(`/api/v1/equips`, { method: Method.GET, query: 
				{ pageNo: 1, 
					pageSize: 5000, 
					engSource: engSource, 
					cityCode: cityCode, 
					sigunguCode: sigunguCode, 
					dongCode: dongCode
				} });

			let result = [] as EquipInfo[];
			// if (useUserStore().getUserType === "owner") {
			// 	let ownerSeq = useUserStore().loginUserOwnerInfo?.ownerSeq;
			// 	for (let i = 0; i < (res.data.value as EquipInfo[]).length; i++) {
			// 		let data = (res.data.value as EquipInfo[])[i] as EquipInfo;
			// 		if (data.ownerSeq === ownerSeq) {
			// 			result.push(data);
			// 		}
			// 	}
			// } else {
			// 	result = res.data.value as EquipInfo[];
			// }

      result = res.data.value;


			this.plainEquipList = (res.data.value.content as EquipInfo[]) ?? [];

	
			this.plainEquipList.sort((a, b) => {
				if (Number(a.engSource) > Number(b.engSource)) return 1;
				else if (Number(a.engSource) < Number(b.engSource)) return -1;
				else return 0;
			});

			this.convertSiteList = this.tempConvertSiteList((res.data.value.content as EquipInfo[]) ?? []);
			return result;
		},
		async getEquipList(engSource: string | undefined = undefined, cityCode: string | undefined = undefined, sigunguCode: string | undefined = undefined, dongCode: string | undefined = undefined) {
      if(engSource === null) engSource = undefined;
      if(cityCode === null) cityCode = undefined;
      if(sigunguCode === null) sigunguCode = undefined;
      if(dongCode === null) dongCode = undefined;

      // console.log(engSource);

      const res = await useCustomFetch<EquipInfo[]>(`/api/v1/equips`, { method: Method.GET, query: { 
        pageNo: 1, 
        pageSize: 5000, 
        engSource: engSource, 
        cityCode : cityCode, 
        sigunguCode: sigunguCode, 
        dongCode: dongCode
      }});

			 

      if(res.data.value.content.length === 1){
        this.selectEquipData(res.data.value.content[0].cid);
      }



			
			// let result = [] as EquipInfo[];
			// if (useUserStore().getUserType === "owner") {
			// 	let ownerSeq = useUserStore().loginUserOwnerInfo?.ownerSeq;
			// 	for (let i = 0; i < (res.data.value as EquipInfo[]).length; i++) {
			// 		let data = (res.data.value as EquipInfo[])[i] as EquipInfo;
			// 		if (data.ownerSeq === ownerSeq) {
			// 			result.push(data);
			// 		}
			// 	}
			// } else {
			// 	result = res.data.value as EquipInfo[];
			// }

			return res.data.value;
		},
		async getEquipListByMap(
			cityCode: string | undefined = undefined,
			sigunguCode: string | undefined = undefined,
			dongCode: string | undefined = undefined,
			prjKind: string | undefined = undefined,
			buildingUsage: string | undefined = undefined,
			prjRegYear: string | undefined = undefined,
			engSource: string | undefined = undefined,
			searchType: string | undefined = undefined,
			searchText: string | undefined = undefined
		) {
			cityCode = cityCode ? cityCode : undefined;
			sigunguCode = sigunguCode ? sigunguCode : undefined;
			dongCode = dongCode ? dongCode : undefined;
			prjKind = prjKind ? prjKind : undefined;
			buildingUsage = buildingUsage ? buildingUsage : undefined;
			prjRegYear = prjRegYear ? prjRegYear : undefined;
			engSource = engSource ? engSource : undefined;
			searchType = searchType ? searchType : undefined;
			searchText = searchText ? searchText : undefined;

			const res = await useCustomFetch(`/api/v1/monitorings/map`, {
				method: Method.GET,
				query: { 
					cityCode: cityCode, 
					sigunguCode: sigunguCode,
					dongCode: dongCode,
					prjKind: prjKind,
					buildingUsage: buildingUsage,
					prjRegYear: prjRegYear,
					engSource: engSource,
					searchType: searchType,
					searchText: searchText 
				},
			});

			return res.data.value;
		},
		async setSelectSite(siteName: string, cid: string | undefined = undefined) {
			const route = useRoute();
			let tempSite: ConvertSiteForm | undefined;

			// cid가 제공된 경우 cid를 우선으로 매칭
			if (cid !== undefined) {
				// 모든 convertSiteList 항목을 순회하면서 cid로 직접 찾기
				// siteName으로 먼저 필터링하지 않음 (버그 수정)
				for (let i = 0; i < this.convertSiteList.length; i++) {
					const isEquip = this.convertSiteList[i].equipList.findIndex(t => t.cid === cid);
					if (isEquip !== -1) {
						tempSite = this.convertSiteList[i];
						break;
					}
				}

				// cid로 찾지 못한 경우에만 siteName으로 찾기
				if (!tempSite) {
					tempSite = this.convertSiteList.find((v) => v.siteName === siteName) as ConvertSiteForm;
				}
			} else {
				// cid가 없는 경우 siteName으로만 찾기
				tempSite = this.convertSiteList.find((v) => v.siteName === siteName) as ConvertSiteForm;
			}

			// tempSite가 없으면 에러 처리
			if (!tempSite) {
				throw new Error(`설비를 찾을 수 없습니다. siteName: ${siteName}, cid: ${cid ?? '없음'}`);
			}

			this.selectSiteInfo = tempSite;

			// 단일 설비이거나 모바일 설비 정보 페이지인 경우 자동 선택
			const isMobileEquipInfoPage = route.fullPath.includes('mobile') && route.fullPath.includes('equipInfo');
			const shouldAutoSelect = this.selectSiteInfo.equipList.length <= 1 || isMobileEquipInfoPage;

			if (shouldAutoSelect) {
				await this.selectEquipData(this.selectSiteInfo.equipList[0].cid as string);
			} else {
				this.selectEquipInfo = {} as EquipInfo;
			}
		},


		tempConvertSiteList(dataList: any) {
			// Map을 사용하여 성능 개선 (O(n) 복잡도)
			const siteMap = new Map<string, ConvertSiteForm>();

			for (let i = 0; i < dataList.length; i++) {
				const equip = dataList[i];
				const existingSite = siteMap.get(equip.siteName);

				if (existingSite) {
					// 기존 사이트에 설비 추가
					existingSite.equipList.push(equip);
				} else {
					// 새 사이트 생성
					siteMap.set(equip.siteName, {
						cid: equip.cid as string,
						siteName: equip.siteName as string,
						ownerSeq: equip.ownerSeq as number,
						rtuId: equip.rtuId as string,
						latitude: equip.latitude as number,
						longitude: equip.longitude as number,
						siteAddr: equip.equipAddr as string,
						dongCode: equip.dongCode as string,
						equipList: [equip],
					});
				}
			}

			// Map을 배열로 변환하여 반환
			return Array.from(siteMap.values());
		},

		async getSiteEquips(engSource: string | undefined = undefined, cid: string, siteName: string | undefined = undefined) {
			try {
				const res = await useCustomFetch<EquipInfo>(`/api/v1/equips/${cid}`, { method: Method.GET });

				if (res.data.value) {
					this.selectEquipInfo = res.data.value as EquipInfo;
					return res.data.value;
				} else {
					// 에러 메시지 오타 수정: meesage -> message
					const errorMessage = res.error.value?.data?.message || '설비 정보를 찾을 수 없습니다.';
					throw new Error(errorMessage);
				}
			} catch (e) {
				Swal.fire({
					html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
					confirmButtonColor: "#1949e9",
					confirmButtonText: "확인",
					width: "85%",
				});
				// 에러를 상위로 전파 (호출부에서 추가 처리 가능하도록)
				throw e;
			}
		},

		async getSiteEquipsSpecInfo(cid: string) {
			const res = await useCustomFetch(`/api/v1/equips/${cid}/component`, { method: Method.GET });
			return res.data.value;
		},

		setEquipCid(equipCid: string) {
			this.equipCid = equipCid;
		},

		async selectEquipData(equipCid: string) {

      if(equipCid === '') {
        this.selectEquipInfo = {} as EquipInfo;
        return;
      }

			const res = await useCustomFetch<EquipInfo>(`/api/v1/equips/${equipCid}`, { method: Method.GET });

			this.selectEquipInfo = res.data.value as EquipInfo;

      return this.selectEquipInfo;
		},
		async resetSelectEquipData() {
      this.selectEquipInfo = {} as EquipInfo;
		},

    async getEquipMeasure(equipCid: string, searchDate: string = moment().format("YYYY-MM-DD")) {
			const res = await useCustomFetch(`/api/v1/equips/${equipCid}/raw-data`, { method: Method.GET, query: { searchDate: searchDate } });
			
      return res.data.value ?? [];
		},

    async getEquipMonitoring(engSource: string, cid: string | undefined = undefined, siteName: string | undefined = undefined) {
			const res = await useCustomFetch<MonitoringBySourceInfo>(`/api/v1/monitor/by-eng-source`, 
				{ method: Method.GET, 
					query: 
					{ 
						engSource: engSource, 
						cid: cid, 
						siteName: siteName 
					} 
				});

			this.selectEquipMonitoringSource = res.data.value as MonitoringBySourceInfo;

			return res.data.value as MonitoringBySourceInfo;
		},

		async getEquipInstallInfo(equipCid: string) {
			const res = await useCustomFetch<EquipInstallInfo>(`/api/v1/equips/${equipCid}/install-info`, { method: Method.GET });
			this.selectEquipInstall = res.data.value as EquipInstallInfo;

			return res.data.value as EquipInstallInfo;
		},

		async getEquipSpecInfo(equipCid: string) {
			const res = await useCustomFetch<EquipComponent>(`/api/v1/equips/${equipCid}/spec-info`, { method: Method.GET });
      // cnosole.log(res.data.value);
			this.selectEquipSpec = res.data.value as EquipComponent;

			return res.data.value as EquipComponent;
		},

		async getEquipRtuInfo(equipRtuID: string) {
			const res = await useCustomFetch(`/api/v1/rtus/${equipRtuID}`, { method: Method.GET });

			this.selectEquipRtu = res.data.value;

			return res.data.value;
		},

		async getMobileEquipList(parameter: {
			ownerSeq: number,
			engSource?: string,
			cityCode? : string,
			sigunguCode?: string,
			dongCode?: string,
		}){

			try{
				const res = await useCustomFetch(`/api/v1/m/equips`, {method: Method.GET, query: {
					ownerSeq: parameter.ownerSeq,
					engSouce: parameter.engSource,
					cityCode: parameter.cityCode,
					sigunguCode: parameter.sigunguCode,
					dongCode: parameter.dongCode
				}});
	
				if(res.data.value){
					return res.data.value
				} else {
					throw new Error(res.error.value?.data.message)
				}
			}catch(e){
				Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
			}
			

		},

		async getEquipMapData(cityCode: string | undefined = undefined, sigunguCode: string | undefined = undefined, dongCode: string | undefined = undefined) {
			const res = await useCustomFetch(`/api/v1/m/monitor/map`, { method: Method.GET, 
				query: 
				{ 
					cityCode: cityCode, 
					sigunguCode: sigunguCode, 
					dongCode: dongCode
				} 
			});
			this.mapEquipInfoList = res.data.value.equipMapItemInfos

			// convertSiteList 초기화 추가
			if (this.mapEquipInfoList && this.mapEquipInfoList.length > 0) {
				this.convertSiteList = this.tempConvertSiteList(this.mapEquipInfoList);
			}

			// this.mapEquipInfoList.sort((a, b) => {
			//   if(a.cid.includes('r') === true){
			//     if(a.cid.includes('r') === true){
			//       return 0;
			//     } else {
			//       return 1;
			//     }
			//   }

			//   if(b.cid.includes('r') === true){
			//     return -1;-
			//   }

			//   return 0;
			// })
			return this.mapEquipInfoList;
		},
    
		async getReportData(ownerSeq: number, baseDate: string, engSource: string, siteName: string | undefined = undefined, cid: string | undefined = undefined) {
			const res = await useCustomFetch<MobileReportInfo>(`/api/v1/m/report`, { 
				method: Method.GET, 
				query: 
				{ 
					ownerSeq: ownerSeq, 
					baseDate: baseDate, 
					engSource: engSource, 
					siteName: siteName, 
					cid: cid
				} 
			});
			return res.data.value;
		},

		async getEquipContractData(cid: string) {
			const res = await useCustomFetch<ContractInfo>(`/api/v1/equips/${cid}/contract-info`, { method: Method.GET });

			return res.data.value;
		},
		async getEquipOwnerInfo(ownerSeq: number, cid: string) {
			const res = await useCustomFetch<OwnerInfo>(`/api/v1/owners/${ownerSeq}`, { method: Method.GET, query: {cid: cid} });
			return res.data.value;
		},
		async getEquipManagerInfo(cid: string, companyKind: string | undefined = undefined) {
			const res = await useCustomFetch<ManagerInfo[]>(`/api/v1/equips/${cid}/manager-info`, { method: Method.GET, query: { companyKind: companyKind } });

			return res.data.value as ManagerInfo[];
		},
		async getForeCasts(engSource: string, siteName:string | undefined = undefined, cid: string | undefined = undefined, searchDate: string) {
			const res = await useCustomFetch(`/api/v1/forecasts/prod`, 
				{ method: Method.GET, 
					query: 
					{ 
						engSource: engSource, 
						siteName: siteName, 
						cid: cid, 
						searchDate: searchDate
					} });

			return res.data.value;
		},

	},
});
